<vc-ref
  *ngFor="let social of socials"
  [resource]="social.link"
  [blank]="true"
  [anchor]="home"
  [ariaLabel]="social.mnemonic"
  class="footer__socialIcon footer__socialIcon--{{ social.mnemonic }}"
>
  <span class="visuallyhidden">{{ social.mnemonic }}</span>
  <img
    *ngIf="social.name === 'Twitter'"
    class="footer__socialIcon  footer__socialIcon--twitter"
    src="/assets/svg/social-twitter.svg"
    alt=""
  />
  <img
    *ngIf="social.name === 'Facebook'"
    class="footer__socialIcon footer__socialIcon--facebook"
    src="/assets/svg/social-facebook.svg"
    alt=""
  />
  <img
    *ngIf="social.name === 'Google'"
    class="footer__socialIcon footer__socialIcon--google"
    src="/assets/svg/social-google.svg"
    alt=""
  />
  <img
    *ngIf="social.name === 'Pinterest'"
    class="footer__socialIcon footer__socialIcon--pinterset"
    src="/assets/svg/social-pinterest.svg"
    alt=""
  />
  <img
    *ngIf="social.name === 'Youtube'"
    class="footer__socialIcon footer__socialIcon--youtube"
    src="/assets/svg/social-youtube.svg"
    alt=""
  />
  <img
    *ngIf="social.name === 'Instagram'"
    class="footer__socialIcon footer__socialIcon--instagram"
    src="/assets/svg/social-instagram.svg"
    alt=""
  />
</vc-ref>
